import {put, takeEvery} from 'redux-saga/effects';
import {createBrowserHistory} from 'history';
import {
    FETCH_CPVALUE_INIT_ACTION,
    FETCH_CPVALUE_SUCCESS_ACTION,
    FETCH_CPVALUE_FAIL_ACTION,
    ADD_CPVALUE_INIT_ACTION,
    ADD_CPVALUE_SUCCESS_ACTION,
    ADD_CPVALUE_FAIL_ACTION
} from './action';
import {push} from 'connected-react-router';
import {appConfig} from '../../config';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var btoa = require('Base64').btoa;
var history = createBrowserHistory();


function* fetchCpvalue() {
    console.log("-----------------------------", );
    const token = localStorage.getItem("token");
    try {
      const res = yield fetch(
        `${appConfig.ip}/cpValue`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      );
      if (!res.ok) {
        let errJSON = {};
        try {
          errJSON = yield res.json();
        } catch {}
        throw Object.assign(res, errJSON);
      } else {
        const resJSON = yield res.json();
        console.log("res----------", resJSON);
        yield put({
          type: FETCH_CPVALUE_SUCCESS_ACTION,
          payload: resJSON
        });
      }
    } catch (err) {
      if (err.ok === false) {
        yield put({ type: FETCH_CPVALUE_FAIL_ACTION, error: err });
      } else {
      }
    }
  }




  function* AddCpvalue(value) {
    console.log("value222222222222222222222222",value);
    try {
      const token = localStorage.getItem("token");
     const data = {
        gst: value.value.gst,
        serviceFee: value.value.serviceFee,
        gatewayFee: value.value.gatewayFee,
        serviceFeePer: value.value.serviceFeePer,
        isActive: value.value.isActive
      };
      console.log("data data data data",data);
  
      const res = yield fetch(`${appConfig.ip}/cpValue`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
      });
  
      if (!res.ok) {
        let errJSON = {};
        try {
          errJSON = yield res.json();
        } catch {
          throw Object.assign(res, errJSON);
        }
      } else {
        const resJSON = yield res.json();
  
        yield put({
          type:  ADD_CPVALUE_SUCCESS_ACTION,
          payload: resJSON
        });
        yield toast.success("Cp value updated successfully", {
          autoClose: 3000
        });
        yield put({
          type:  FETCH_CPVALUE_INIT_ACTION
        });
      }
    } catch (err) {
      if (err.ok === false) {
        yield put({
          type:  ADD_CPVALUE_FAIL_ACTION,
          error: err
        });
      }
    }
  }


export function* cpvalueActionWatcher() {
    yield takeEvery(FETCH_CPVALUE_INIT_ACTION, fetchCpvalue);
    yield takeEvery(ADD_CPVALUE_INIT_ACTION, AddCpvalue);
}

